export const SECTION_TITLES = [
  'Favorite Artists',
  'Favorite Tracks',
  'Favorite Genres',
  'Streaming Analysis'
];
